export enum NylasState {
  INVALID_CREDENTIALS = 'invalid-credentials',
  INVALID = 'invalid',
  EXCEPTION = 'exception',
  SYNC_ERROR = 'sync-error',
  STOPPED = 'stopped',
  PARTIAL = 'partial',
  RUNNING = 'running',
}

export interface NylasEnvironment {
  clientId: string;
  redirectUri: string;
  scopes: string[];
}
